const Ignored = () => {
  return <></>;
};

export default Ignored;
